import React from 'react';
import { Icon } from 'legacy-packages/ft-cb';

const ErrorMessage = ({ className, children }) => (
  <div className={`error-wrap ${className || ''}`}>
    <Icon
      name="filled_circle_exclamation"
      className="alert-icon error"
      size="2em"
    />
    <div className="error error-msg">{children}</div>
  </div>
);

export default ErrorMessage;
